var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('deck-form',{model:{value:(_vm.deck),callback:function ($$v) {_vm.deck=$$v},expression:"deck"}})}
var staticRenderFns = []

export { render, staticRenderFns }